// /root/boomlotto/client/src/pages/Lobby.jsx
import React, { useEffect, useMemo, useState } from "react";
import { io } from "socket.io-client";
import { fetchMe } from "../api";

export default function Lobby({ token, onEnterRoom, onEnterLoto }) {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState("");
  const [joining, setJoining] = useState(false);

  // Для CRA: REACT_APP_API_URL, иначе текущий домен
  const socketBase = useMemo(() => {
    return process.env.REACT_APP_API_URL || window.location.origin;
  }, []);

  // /loto socket
  const lotoSocket = useMemo(() => {
    if (!token) return null;

    // Важно: namespace /loto + path /socket.io
    return io(`${socketBase}/loto`, {
      transports: ["websocket", "polling"],
      auth: { token },
      path: "/socket.io",
    });
  }, [token, socketBase]);

  useEffect(() => {
    let mounted = true;

    async function load() {
      try {
        const me = await fetchMe(token);
        if (!mounted) return;
        setUser(me.user || me);
      } catch (e) {
        console.error("fetchMe error:", e);
      }
    }

    load();
    return () => {
      mounted = false;
    };
  }, [token]);

  useEffect(() => {
    if (!lotoSocket) return;

    const onConnect = () => setStatus("loto socket connected");
    const onDisconnect = () => setStatus("loto socket disconnected");
    const onErr = (p) => setStatus(`ERROR: ${p?.error || "unknown"}`);

    const onMyCard = (p) => {
      setStatus("card received");
      if (typeof onEnterLoto === "function") {
        onEnterLoto({ roomId: "classic", card: p?.card || null });
      } else {
        console.log("MY CARD:", p?.card);
      }
    };

    lotoSocket.on("connect", onConnect);
    lotoSocket.on("disconnect", onDisconnect);
    lotoSocket.on("loto_error", onErr);
    lotoSocket.on("loto_my_card", onMyCard);

    return () => {
      lotoSocket.off("connect", onConnect);
      lotoSocket.off("disconnect", onDisconnect);
      lotoSocket.off("loto_error", onErr);
      lotoSocket.off("loto_my_card", onMyCard);
      try {
        lotoSocket.disconnect();
      } catch (_) {}
    };
  }, [lotoSocket, onEnterLoto]);

  const displayName = user?.firstName || user?.username || "Игрок";

  async function joinClassic() {
    if (!lotoSocket) {
      setStatus("socket not ready");
      return;
    }
    setJoining(true);
    setStatus("joining classic...");
    lotoSocket.emit("loto_join", { roomId: "classic" });
    setTimeout(() => setJoining(false), 800);
  }

  return (
    <div style={{ padding: 16, color: "#fff", minHeight: "100vh" }}>
      <div style={{ fontSize: 42, fontWeight: 900, marginBottom: 10 }}>
        BoomLotto
      </div>

      {/* Маркер версии (потом уберёшь) */}
      <div
        style={{
          display: "inline-block",
          padding: "6px 10px",
          borderRadius: 10,
          background: "rgba(255,255,255,0.08)",
          border: "1px solid rgba(255,255,255,0.14)",
          fontSize: 12,
          opacity: 0.9,
          marginBottom: 14,
        }}
      >
        VERSION: 2026-01-24 10:45 (Lobby.jsx)
      </div>

      <div style={{ opacity: 0.9, marginBottom: 8 }}>👤 {displayName}</div>
      <div style={{ opacity: 0.9, marginBottom: 8 }}>
        🎟 Билеты: {user?.tickets ?? 0}
      </div>
      <div style={{ opacity: 0.9, marginBottom: 18 }}>
        ⭐ Premium: {user?.premiumTickets ?? 0}
      </div>

      <div style={{ fontSize: 30, fontWeight: 900, marginBottom: 12 }}>
        Комнаты
      </div>

      {/* Карточка комнаты — чтобы точно было видно */}
      <div
        style={{
          width: "100%",
          padding: 14,
          borderRadius: 16,
          background: "rgba(255,255,255,0.06)",
          border: "1px solid rgba(255,255,255,0.16)",
          backdropFilter: "blur(2px)",
        }}
      >
        <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 10 }}>
          CLASSIC • 5 карточек
        </div>

        <button
          onClick={joinClassic}
          disabled={joining}
          style={{
            width: "100%",
            padding: "16px 12px",
            borderRadius: 14,
            border: "1px solid rgba(255,255,255,0.25)",
            background: joining ? "rgba(255,255,255,0.10)" : "rgba(255,255,255,0.14)",
            color: "#fff",
            fontSize: 18,
            fontWeight: 900,
            cursor: joining ? "not-allowed" : "pointer",
          }}
        >
          🎲 Играть в Русское Лото (CLASSIC)
        </button>

        <div style={{ marginTop: 10, opacity: 0.85, fontSize: 13, lineHeight: 1.4 }}>
          Цена: 1 MR • Мест: 5 • Приз: 4 MR
          <br />
          Бочонок каждые 3 сек • Победа: 15/15
        </div>

        {status ? (
          <div
            style={{
              marginTop: 12,
              padding: "8px 10px",
              borderRadius: 12,
              background: "rgba(0,0,0,0.25)",
              border: "1px solid rgba(255,255,255,0.12)",
              opacity: 0.95,
              fontSize: 13,
              wordBreak: "break-word",
            }}
          >
            {status}
          </div>
        ) : null}
      </div>
    </div>
  );
}
